import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTracker } from 'components/Tracker';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Spa from '@material-ui/icons/Spa';
import LocalShipping from '@material-ui/icons/LocalShipping';
import People from '@material-ui/icons/People';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { BasicFooter, injectIntl } from 'components';
import { selectState } from 'redux/selectors';
import { clearAuthToken } from 'redux/auth/actions';
import Login from './components/Login';
import RecoverPasswordDialog from './components/RecoverPasswordDialog';
import VerificationDialog from './components/VerificationDialog';
import TopNav from './components/TopNav';
import SignUp from './components/SignUp';
import qs from 'query-string';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SearchBar from 'material-ui-search-bar';
import {noop} from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'helpers/detect-mobile';


const styles = () => ({
  rootSearch: {
    flexDirection: 'row-reverse',
    transition: 'width 1s',
    zIndex: 1201,
    height: '50px',
    width: isMobile ? '300px' : '450px',
    margin: 'auto'
  },
  icon: {
    color: 'grey',
    height: 15,
    width: 15,
  },
  iconOpen: {
    opacity: 1,
    color: '#4695ec !important',
  },
  iconButton: { opacity: 1 },
  searchContainer: {
    width: 'calc(100% - 48px - 16px)',
    margin: 'auto 16px auto 0',
  },
  searchIconButton: {
    marginRight: 0,
    marginLeft: -48,
    padding: 0,
  },
});

class Home extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
  };

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    history: PropTypes.shape({
      location: PropTypes.shape({}).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
    tokenInfo: ImmutablePropTypes.mapContains({
      success: PropTypes.string,
    }).isRequired,
    clearAuthToken: PropTypes.func.isRequired,
    classes: PropTypes.shape({}).isRequired,

  };

  state = { movingRight: false, movingLeft: false, email: '', password: '', userTypeTab: 'consumer', requiredLoginOpen: false, searchText: ''};


  componentDidMount() {
    document.body.classList.add('body-home');
    window.scrollTo(0, 0);

    let queryParams = [];
    let query;
    if (this.props.history.location.hash !== '#login'){
      query = (this.props.history.location.hash.split('/')).length > 1 ? (this.props.history.location.hash.split('/')[1] || '').split('?')[1] : (this.props.history.location.hash.split('/')[0] || '').split('?')[1];
      queryParams= qs.parse(query);
    } else if (this.props.history.location.search !== ''){
      query = this.props.history.location.search.slice(1);
      if (decodeURIComponent(query).split('/')[1]){
        queryParams= qs.parse(decodeURIComponent(query).split('/')[1].split('?')[1]);
      }
    }
    if(queryParams && queryParams.email){
      this.setState({email: queryParams.email});
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('body-home');
  }

  get showSignup() {
    const {
      history: {
        location: {
          hash,
        },
      },
    } = this.props;

    return hash.split('?')[0] === '#signup';
  }

  switchForms = () => {
    const { history } = this.props;
    const { showSignup } = this;

    if (showSignup) {
      this.setState({ movingLeft: true });
      setTimeout(() => this.setState({ movingLeft: false }), 200);
    } else {
      this.setState({ movingRight: true });
      setTimeout(() => this.setState({ movingRight: false }), 100);
    }
    const { redirect_url: redirectUrl, profileUrl, vendorEmail, asConsumer, ...rest } = qs.parse(history.location.search.slice(1));
    const encodedUrl = encodeURIComponent(`${history.location.pathname}?${qs.stringify(rest)}`);
    const urlPathname = redirectUrl ? `/?redirect_url=${encodeURIComponent(redirectUrl) || encodedUrl}#` : '';
    const profilePathname = profileUrl ? `/?profileUrl=${encodeURIComponent(profileUrl) || encodedUrl}&vendorEmail=${vendorEmail}#` : '';
    const asConsumerPathname = asConsumer ? `/?asConsumer=${encodeURIComponent(asConsumer)}#` : '';
    setTimeout(() => {
      if (redirectUrl) {
        history.push(`${urlPathname}${showSignup ? 'login' : 'signup'}`);
      } else if (profileUrl) {
        history.push(`${profilePathname}${showSignup ? 'login' : 'signup'}`);
      } else if (asConsumer) {
        history.push(`${asConsumerPathname}${showSignup ? 'login' : 'signup'}`);
      } else {
        history.push(`/#${showSignup ? 'login' : 'signup'}`);
      }
    }, 100);
  }

  setUserTypeTab = (userType) => {
    this.setState({ userTypeTab: userType });
    return userType;
  }

  changeEmail = (email) => {
    this.setState({
      email: email
    })
  }

  changePassword = (password) => {
    this.setState({
      password: password
    })
  }

  handleRequiredLoginDialogOpen = () => {
    this.setState({ requiredLoginOpen: true });
  }

  handleRequiredLoginDialogClose = () => {
    this.setState({ requiredLoginOpen: false });
  }

  redirectToRolePage = (roleName) => {

    if (roleName.toLowerCase().includes('farm')) {
      return this.props.history.push('/features?category=farm');
    }else if (roleName.toLowerCase().includes('distributor')) {
      return this.props.history.push('/features?category=distributor');
    }else if (roleName.toLowerCase().includes('buyer', 'restaurant')){
      return this.props.history.push('/features?category=restaurant');
    }
  }

  getCheckedBox = (roleSection) => {
    let total = 0;
    if(roleSection) {
      roleSection.forEach((role) => {
        if (role.get('show')) {
          total++;
        } 
      });
    }
    return total;
  }

  onSearch = (searchText) => {
    const { history } = this.props;
    history.push(`/marketplace/?search=${searchText}`);
  }

  render() {
    const { brands } = this.context;
    const appTitle = brands.title || '';
    const appSlogan = brands.slogan || '';
    const logoUrl = brands.logoUrl || '';
    const appHeader = brands.homePageHeader || '';
    const clientsSectionTitle = brands.clientsTitle || '';
    const clientsSectionDescription = brands.clientsDescription || '';
    const testimonialsSectionTitle = brands.testimonialsTitle || '';
    const testimonialsSectionDescription = brands.testimonialsDescription || '';
    const {
      formatMessage,
      history: { location, push },
      tokenInfo,
      clearAuthToken,
      history,
    homeSections,
    classes
    } = this.props;
    const { movingRight, movingLeft, userTypeTab, requiredLoginOpen,searchText } = this.state;
    const { showSignup } = this;
    const { accessToken, user, type } = tokenInfo.toJS() || {};
    const { hash } = location;
    const [subPath, query] = (hash.split('/')[1] || '').split('?');
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    let recoverPasswordDialog = null;
    let verificationDialog = null;
    const aboutSection  = homeSections.get('aboutSection');
    const rolesSection = homeSections.get('rolesSection');
    const testimonailsSection = homeSections.get('testimonailsSection');
    const clientsSection = homeSections.get('clientsSection');
    const totalCheckedBox =  this.getCheckedBox(rolesSection);

    if (subPath === 'passwordRecovery') {
      const valueStrings = query.split('&');
      const queryParams = {};

      valueStrings.forEach((valueString) => {
        const [name, value] = valueString.split('=');
        queryParams[name] = value;
      });

      recoverPasswordDialog = (
        <RecoverPasswordDialog
          {...queryParams}
          formatMessage={formatMessage}
          push={push}
        />
      );
      clearAuthToken();
    } else if (subPath === 'verifyEmail') {
      const valueStrings = query.split('&');
      const queryParams = {};

      valueStrings.forEach((valueString) => {
        const [name, value] = valueString.split('=');
        queryParams[name] = value;
      });
      verificationDialog = (
        <VerificationDialog
          {...queryParams}
          formatMessage={formatMessage}
          push={push}
          location={location}
        />
      );
      clearAuthToken();
    } else if (accessToken && user && user.id) {
      if (type === 'signup') {
        return <Redirect to="/settings" />;
      }
      const role = {
        2: 'Buyer',
        3: 'Distributor',
        4: 'Seller',
        5: 'Consumer',
      }[user.account.currentRoleId] || 'Personal';
      const { redirect_url: redirectUrl } = qs.parse(history.location.search.slice(1));
      if (redirectUrl) {
        return <Redirect to={`${decodeURI(redirectUrl)}`} />;
      } else {
        return <Redirect to="/track-orders" />;
      }
    }
    return (
      <div className="home-page">
        <div className="top-section row">
        <div className="heading col-md-6">
            <img
              alt="sun"
              className="logo-img"
              src={logoUrl}
            /> 
            <h1 className="d-sm-down-none">{appSlogan && formatMessage(appSlogan)}</h1>
            <div>
              <Link to="/about" style={{marginRight: 30}}>
                <Button variant="outlined" color="inherit">
                  {formatMessage('Learn More')}
                </Button>
              </Link>
              <a href="https://calendly.com/freshr/30min?month=2020-03">
                <Button variant="outlined" color="inherit">
                  {formatMessage('Request a DEMO')}
                </Button>
              </a>
            </div>
            <div style={{marginBottom: isMobile ? 30 : 0, marginTop: isMobile ? 20 : 40}}>
              <div style={{marginBottom: 20, fontSize: 22}}>  {formatMessage('Marketplace')}</div>
              <SearchBar
                  autoFocus
                  onChange={noop}
                  onKeyPress={(e) => {
                    if (e.which === 13) {
                      this.onSearch(e.target.value);
                    }
                  }}
                  onRequestSearch={noop}
                  placeholder={formatMessage('Search Items')}
                  value={searchText}
                  classes={{
                    root: classes.rootSearch,
                    icon: classes.iconOpen,
                    iconButton: classes.iconButton,
                    searchContainer: classes.searchContainer,
                    searchIconButton: classes.searchIconButton,
                  }}
                />
            </div>

          </div>
          <div className="forms col-md-6">
            <Paper className="auth-form" style={{ padding: 20, width: 368, maxWidth: '100%', height: 410, cursor: 'auto', margin: '0px auto' }}>
              <div style={{ justifyContent: 'center', marginBottom: '-45px' }} className="icon-section d-flex">
                <div
                  style={{
                    backgroundColor: 'gray',
                    borderRadius: '50%',
                    padding: 10,
                    alignItems: 'center',
                  }}
                  className="icon-wrapper d-flex">
                  <LockOutlined style={{ color: 'white' }} />
                </div>
              </div>
              <div className="register-tab d-flex justify-content-between">
                <div className={`overlay ${movingRight && 'moving-right'} ${movingLeft && 'moving-left'} ${showSignup ? 'signup' : 'login'}`} />
                <h3 className={`btn-sign ${showSignup ? '' : 'active'}`} onClick={this.switchForms}>{formatMessage('Log in')}</h3>
                <h3 className={`btn-sign ${showSignup ? 'active' : ''}`} onClick={this.switchForms}>{formatMessage('Sign up')}</h3>
              </div>
              {showSignup
                ? <SignUp formatMessage={formatMessage} email={this.state.email} handleEmail={this.changeEmail} password = {this.state.password} handlePassword={this.changePassword} userTypeTab={userTypeTab} setUserTypeTab={this.setUserTypeTab} />
                : <Login formatMessage={formatMessage} history={this.props.history} email={this.state.email} handleEmail={this.changeEmail} password={this.state.password} handlePassword={this.changePassword}/>
              }
            </Paper>
            { !isChrome && (
              <div style={{ fontSize: '18px', paddingTop: '16px', textAlign: 'center' }}>
                Use Chrome Browser for FRESHr&nbsp;
                <a target="_blank" href="https://www.google.com/chrome/?brand=CHBD&gclid=Cj0KCQjw6eTtBRDdARIsANZWjYZdDBYBWh6cpmrAnv1boTx0UHkOfo9CZxp5m-BNQMgsG5QdaQnrP4EaAhn1EALw_wcB&gclsrc=aw.ds">
                  Download
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="blocks">
          {
            rolesSection && rolesSection.map(role => (
              <Paper className="block-container"
              onClick={ () => this.props.history.push(`/features?category=${role.get('category')}`)}
              >
                {role.get('category').toLowerCase() === 'farm' ? 
                  <Spa className="block-icon" color="disabled" /> :
                  (role.get('category').toLowerCase() === 'distributor' ? 
                    <LocalShipping className="block-icon" color="disabled" /> :
                    <People className="block-icon" color="disabled" />
                  )
                }
                
                <span className="title">{formatMessage(role.get('roleName'))}</span>
                <p className="mt-2">{formatMessage(role.get('topDescription'))}</p>
                <img className="block-image" alt="" src={role.get('image')} />
                <p className="mt-3">{formatMessage(role.get('bottomDescription'))}</p>
                <Button color="primary">
                  {formatMessage('Features')}
                </Button>
              </Paper>
            ))
          }    
        </div>
        <div className="home-section">
        {
          aboutSection && aboutSection.map(section => (
            <div>
              <h2 className= "title"> {section.get('aboutTitle')} </h2>
              <p> 
                {section.get('aboutDescription')} 
                {/* <Link to="/about">{formatMessage('more')}</Link> */}
              </p>
              
              <h2 className= "title"> {section.get('missionTitle')} </h2>
              <p> {section.get('missionDescription')} </p>

              <h2 className= "title"> {section.get('vissionTitle')} </h2>
              <p> {section.get('vissionDescription')} </p>

            </div>
          ))
        } 
        </div>
        <div className="home-section">
          <div className= "title-section">
            <h2>{testimonialsSectionTitle}</h2>
            <div className="desc">{testimonialsSectionDescription} </div>    
          </div>
          <Grid className= "grid-section" container spacing={40} alignItems="flex-start">
          {
            testimonailsSection && testimonailsSection.map(section => (  
                <Grid item xs={12} sm={4} md={4}>
                  <Card>
                    <CardContent>
                      { section.get('cardImage') && 
                      <div className ="card-image">
                        <img class="block-image" alt="" src={section.get('cardImage')}></img>
                      </div>
                      }
                      <div className ="card-name">
                        {formatMessage(section.get('cardName'))}
                      </div>
                      <div className= "card-description">
                        {formatMessage(section.get('cardText'))}
                      </div>
                    </CardContent>
                  </Card>    
                </Grid>  
            ))
          }
          </Grid> 
        </div>
        <div className="home-section customers">
            <div className= "title-section">

              <h2>{clientsSectionTitle}</h2>
              <div className="desc">{clientsSectionDescription} </div>    
            </div>
            <Grid className= "grid-section" container alignItems="flex-end" >
              {
                 clientsSection && clientsSection.map(section => (              
                  <Grid item xs={12} sm={3} md={3} className="grid-item">
                    <div>
                      <img className="company-image" alt="" src={section.get('clientImage')} />
                    </div>
                  </Grid>  
              ))
              }
            </Grid>
        </div>  

        {recoverPasswordDialog}
        {verificationDialog}
        <BasicFooter />
        <Dialog
          open={requiredLoginOpen}
          onClose={this.handleRequiredLoginDialogClose}
          >
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div>
                <div style={{ marginBottom: '20px', fontSize: '20px' }}>
                  {formatMessage('Please Log-In or Sign-Up.')}
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button onClick={this.handleRequiredLoginDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('auth', 'tokenInfo')(state, 'tokenInfo'),
  ...selectState('options', 'homeSections')(state),
});
/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  clearAuthToken: payload => dispatch(clearAuthToken(payload)),
});

const wrappedHome = connect(mapStateToProps, mapDispatchToProps)(injectIntl(withTracker(Home)));
wrappedHome.displayName = 'Home';

export default withStyles(styles)(wrappedHome);
